import request from '@/utils/request'

const url = 'admin/order'
/**
 * 门店管理接口API
 */

const api = {
  Query(data) {
    return request({
      url: `${url}/list`,
      method: 'post',
      data
    })
  },

  /**
     * 删除Site
     * @returns
     */
  Delete(data) {
    return request({
      url: `${url}/destroy`,
      method: 'post',
      data
    })
  },

  /**
     * 详情Site
     * @returns
     */
  Detail(id) {
    return request({
      url: `${url}/detail`,
      method: 'post',
      params: { id }
    })
  },
  orderdetail(data) {
    return request({
      url: `${url}/orderdetail`,
      method: 'post',
      data
    })
  },
  /**
     * 编辑Site
     * @returns
     */
  Update(data) {
    return request({
      url: `${url}/createOrUpdate`,
      method: 'post',
      data
    })
  },

  /**
     * 添加Site
     * @returns
     */
  Create(data) {
    return request({
      url: `${url}/createOrUpdate`,
      method: 'post',
      data
    })
  },
  // 查询订单数据
  getOrderStatistics(data) {
    return request({
      url: `${url}/getOrderStatistics`,
      method: 'post',
      data
    })
  },
  // 退款
  toRefound(data) {
    return request({
      url: `${url}/toRefound`,
      method: 'post',
      data
    })
  }

}

export default api
